export default function isObject(value) {
    return !!(value && value instanceof Object);
}
;
